import apiFetch from '../apiFetch'

export default function (fecha, token) {
  return apiFetch({endPoint: `Planning/getVerracosPlanificados`, method: 'POST', body: fecha, token: token})
}